import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

type AiChatIconProps = ToolIconProps & {
  /** ضخامت خط حباب. پیش‌فرض همان فایل آیکون است. */
  lineWidth?: number;
};

export function AiChatIcon({ lineWidth = 3, ...props }: AiChatIconProps) {
  return (
    <ToolIconFrame {...props}>
      <path
        d="M12 7H36A7 7 0 0 1 43 14V28A7 7 0 0 1 36 35H21L12 43V35A7 7 0 0 1 5 28V14A7 7 0 0 1 12 7Z"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth={lineWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.00 12.50C24.85 17.32 27.68 20.15 32.50 21.00C27.68 21.85 24.85 24.68 24.00 29.50C23.15 24.68 20.32 21.85 15.50 21.00C20.32 20.15 23.15 17.32 24.00 12.50Z"
        fill={toolIconSecondary}
        stroke={toolIconSecondary}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
